import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Mutation, namespace } from "vuex-class";
import { IBaseHistoryParameter } from "../../../models/base-history-paramter";
import { DataHelper } from "../../../utils/data-helper";
import TimeLinePopoverComponent from "../timeline-popover";
import { LabelSetting } from "../../../i18n/locale-helper";
import { storeModules } from "../../../store";
import { DrawerModel, IDrawerModel } from "../../../models/common/drawer.model";
import { DRAWER_NAME } from "../../../common/drawer-component.constants";

const CommonMutation = namespace(storeModules.Common, Mutation);
@Component({
  template: require("./template.html"),
  components: {
    "timeline-popover": TimeLinePopoverComponent
  }
})
class RelationsComponent extends Vue {
  @Prop() searchData: IBaseHistoryParameter;

  @Prop()
  isLoading: boolean; 

  @Prop({ default: "Date", type: [String] })
  datetimeKey: string;

  @Prop()
  data: any[];

  @Prop({default: null})
  scrollbarOffset: number;

  @Prop({default:null})
  fixHeight: number;
  tableHeight: number = 200;

  @CommonMutation setVisibleDrawerModel: (payload: IDrawerModel) => void;

  get lblSetting() {
    return LabelSetting.Property;
  }
  get lblGlobal() {
    return LabelSetting.Global;
  }

  get tableData() {
    return this.data.map((t) => {
      let clone = DataHelper.deepClone(t);
      clone["timelineVisible"] = false;
      return clone;
    });
  }

  getIndex(row) {
    return this.tableData.indexOf(row);
  }

  openPersonDetail(row) {
    console.log("openPersonDetail", row);
    this.setVisibleDrawerModel(new DrawerModel({
        componentName: DRAWER_NAME.PERSON_DETAIL,
        props: {
            objectId: row.PersonId
        },
        title: 'PERSONS'
    }));
  }

  openPopover(row) {
    console.log("openPopover", row);

    this.setVisibleDrawerModel(new DrawerModel({
        componentName: DRAWER_NAME.HISTORY_TIMELINE_POPOVER,
        props: {
            data: row,
            datetimeKey: this.datetimeKey,
            dataPropKey: "listOfPropertyPropertyProspectHistory",
            index: this.getIndex(row),
            searchData: this.searchData,
            scrollbarOffset: 10,
        },
        title: row.Name,
        showSaveBtn: false
    }))
}

  mounted(){
    this.$nextTick(()=>{
      this.tableHeight = window.innerHeight - 450;
    });
  }
}

export default RelationsComponent;
